import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-job-income-return-en-v2',
    templateUrl: './job-income-return-en-v2.component.html',
    styleUrls: ['./job-income-return-en-v2.component.css'],
    standalone: false
})
export class JobIncomeReturnEnV2Component implements OnInit, OnChanges {

  constructor() { }

  @Input() returnData
  @Input() printActive:boolean

  govtSalary:any = {}
  nongovtSalary:any = {}
  jobAvailable: boolean = false
  govtSum: any
  nongovtSum: any

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.jobAvailable = this.returnData?.headSummery?.incomeHeadsList?.filter((item)=>item === 'Income from Employment')[0] ? true : false

    this.returnData?.headSummery?.salarySummery?.GOVT_EMPLOYMENT_SUMMARY?.forEach(item => {
      this.govtSalary[item.titleKey] = {
        gross: item.gross,
        exempted: item.exempted,
        taxable: item.taxable
      };
    });
    this.returnData?.headSummery?.salarySummery?.NON_GOVT_EMPLOYMENT_SUMMARY?.forEach(item => {
      this.nongovtSalary[item.titleKey] = {
        gross: item.gross,
        exempted: item.exempted,
        taxable: item.taxable
      };
    });

    this.govtSum = this.govtSalary?.IS_SUM?.gross
    this.nongovtSum = this.nongovtSalary?.IS_SUM?.gross

  }

}
